import React, { Component } from 'react';
import { convertDateStringToFormat, getLastNDays } from '../../../lib/DateUtils';
import { bytesToString } from '../../../lib/FormatUtils';

import map from 'lodash/map';
import mapKeys from 'lodash/mapKeys';
import has from 'lodash/has';
import { DisplayModes } from './chartConstants';

import BarChart from '../graph/BarChart';

class DataVolumeBarChartView extends Component {
  render() {
    let { data, forDateRange, mode } = this.props;
    let lastNDays = getLastNDays(forDateRange, 'MM/DD');

    let xValues = lastNDays;

    let metricsInLocalTime = has(data, 'metrics')
      ? mapKeys(data.metrics, (v, k) => {
          return convertDateStringToFormat(k, 'MM/DD', false);
        })
      : null;

    let metricsData = map(lastNDays, (d) => {
      let metricForDay = has(metricsInLocalTime, d) ? metricsInLocalTime[d] : null;
      return {
        x: d,
        y:
          metricForDay && has(metricForDay, this.props.yAttribute)
            ? metricForDay[this.props.yAttribute]
            : 0,
      };
    });

    let yValues = map(metricsData, (m) => m.y);

    let yMax = Math.max(...yValues);
    let yDefault = 10000;

    if (mode === DisplayModes.ERROR_COUNT) {
      yDefault = 1000;
    } else if (mode === DisplayModes.DATA_VOLUME) {
      yDefault = 10000000;
    }

    let domain = yMax > 0 ? [0, yMax] : [0, yDefault];
    let yDataDomain = yMax > 0 ? [0, yMax * 1.4] : [0, yDefault];
    return (
      <div>
        <BarChart
          tickValues={xValues}
          domain={domain}
          data={metricsData}
          height={250}
          dataDomain={{
            y: yDataDomain,
          }}
          yTickFormat={this.props.yTickFormat}
          yLabelFormat={this.props.yLabelFormat}
          xLabel={this.props.xLabel}
          yLabel={this.props.yLabel || ''}
        />
      </div>
    );
  }
}

DataVolumeBarChartView.defaultProps = {
  mode: DisplayModes.DATA_VOLUME,
  forDateRange: 7,
  data: {},
  yTickFormat: (d) => {
    return bytesToString(d, '.0');
  },
  yLabelFormat: (d) => {
    return bytesToString(d.y, '.1');
  },
  yAttribute: 'size',
  xAttribute: 'time',
  xLabel: 'Date (UTC time)',
};

export default DataVolumeBarChartView;
